import { zodResolver } from '@hookform/resolvers/zod';
import { Button, Group, Paper } from '@mantine/core';
import { IconCancel as CancelIcon, IconDeviceFloppy as SaveIcon } from '@tabler/icons-react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';

import { FreeText } from '@/module/ResearchCenter';

import { ContentEditableControl } from '@/core/components';

interface CriteriaProjectFreeTextChangeFormProps {
  onChange: (freeText: FreeText) => void;
  onCancel: () => void;

  defaultValues: Partial<FreeText>;

  isSubmitting: boolean;
}

export const schema = z.object({
  text: z.string().min(3),
  id: z.number().nullish(),
});

export type FreeTextSchema = z.infer<typeof schema>;

export function CriteriaProjectFreeTextChangeForm({
  onChange,
  defaultValues,
  isSubmitting,
  onCancel,
}: CriteriaProjectFreeTextChangeFormProps) {
  const { t } = useTranslation();

  const form = useForm<FreeTextSchema>({
    defaultValues,
    resolver: zodResolver(schema),
  });

  return (
    <FormProvider {...form}>
      <Paper
        mb="10px"
        p="sm"
        shadow="sm"
        component="form"
        onSubmit={form.handleSubmit(onChange)}
      >
        <input
          name="id"
          type="hidden"
        />
        <ContentEditableControl<FreeTextSchema>
          withAsterisk
          name="text"
          label={t('centerReport.free.text')}
          isSubmitting={isSubmitting}
        />
        <Group
          mt="lg"
          justify="flex-end"
        >
          {onCancel && (
            <Button
              size="sm"
              leftSection={<CancelIcon />}
              variant="outline"
              onClick={onCancel}
              disabled={isSubmitting}
            >
              {t('button.cancel')}
            </Button>
          )}
          <Button
            size="sm"
            leftSection={<SaveIcon />}
            type="submit"
            disabled={isSubmitting}
            loading={isSubmitting}
          >
            {t('button.save')}
          </Button>
        </Group>
      </Paper>
    </FormProvider>
  );
}
